import { useRef, useState } from "react";
import { prepareReceiptImages } from "../lib/image.js";

// One-tap receipt capture: opens the camera directly (must be triggered by a
// user tap — iOS blocks programmatic camera opens), resizes, uploads, runs OCR
// server-side, then hands {id, ocr, ocrError} to the caller.
export default function SnapReceiptButton({ label = "📷 Snap receipt", className = "", onCaptured }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function onPick(e) {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      const { original, thumb } = await prepareReceiptImages(file);
      const form = new FormData();
      form.append("original", original, "original.jpg");
      form.append("thumb", thumb, "thumb.jpg");
      form.append("client_id", crypto.randomUUID().replace(/-/g, ""));
      const res = await fetch("/api/receipts", { method: "POST", body: form, credentials: "include" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Upload failed");
      onCaptured?.({ id: data.id, ocr: data.ocr, ocrError: data.ocr_error });
    } catch (err) {
      setError(err.message === "Failed to fetch" ? "No connection — receipt capture needs signal for now." : err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={onPick} />
      <button type="button" onClick={() => fileRef.current?.click()} disabled={busy} className={className}>
        {busy ? "Reading receipt…" : label}
      </button>
      {error && <p className="mt-1 text-center text-xs text-red-600">{error}</p>}
    </>
  );
}
